<div class="uk-padding-small">
  <ags-demandes-encadrement-details
    [header-background]="'primary'"
    [header-color]="'colored'"
    (demandesOutput)="getDemandes($event)"></ags-demandes-encadrement-details>
</div>
